import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import {remCalc} from '../../theme/_utils'

const ReviewScoreIcon = ({id, bvData = 'inline_rating'}) => {
    return (
        <Box h={remCalc(27)}>
            {id && (
                <>
                    <div
                        data-bv-show={bvData}
                        data-bv-product-id={id.replace(/\s+/g, '_').replace(/[:+/]/g, '_')}
                    ></div>
                    <reevoo-badge
                        type="product"
                        sku={id.replace(/[^a-zA-Z0-9]/g, '')}
                        name="b_product_stars_rect_7_desktop"
                    ></reevoo-badge>
                </>
            )}
        </Box>
    )
}

ReviewScoreIcon.propTypes = {
    id: PropTypes.string.isRequired,
    bvData: PropTypes.string,
}

export default ReviewScoreIcon
